import Icon from '@uikit/components/Icon/Icon';
import { CSSProperties } from 'react';
import {
  CSS_VAR_COLOR,
  CSS_VAR_DESKTOP_SCALE,
  CSS_VAR_FONT_SIZE,
} from '../../constants/css';
import { IconID } from '../../types/icon';
import styles from './List.module.scss';

type ListRow = {
  content: string;
  icon?: IconID;
  color?: string;
};

export type ListProps = {
  rows: ListRow[];
  icon?: IconID;
  color?: string;
  numeric?: boolean;
  fontSize?: number;
  desktopScale?: number;
};

export const List = ({
  rows,
  icon = 'info-checkmark',
  color,
  numeric = false,
  fontSize,
  desktopScale,
}: ListProps) => {
  return (
    <div className={styles.base}>
      {rows.map((row, index) => {
        const style = {
          [CSS_VAR_COLOR]: row.color ?? color,
          [CSS_VAR_FONT_SIZE]: fontSize,
          [CSS_VAR_DESKTOP_SCALE]: desktopScale,
        } as CSSProperties;

        return (
          <div className={styles.item} style={style} key={index}>
            {numeric && (
              <div className={styles.number}>
                <strong>{index + 1}</strong>
              </div>
            )}

            {(row.icon || icon) && !numeric && (
              <div className={styles.icon} style={style}>
                <Icon
                  id={row.icon ?? icon}
                  variant={
                    icon === 'info-checkmark'
                      ? 'action/info-checkmark'
                      : 'user/thumbs-up'
                  }
                  size="iconSize24"
                />
              </div>
            )}
            <span className={styles.content}>{row.content}</span>
          </div>
        );
      })}
    </div>
  );
};
